<template>
	<div>
		<el-carousel height="460px">
			<el-carousel-item v-for="(item, index) in sliders" :key="index">
				<div :style="{backgroundImage: 'url(' + item.img + ')'}" class="slider_img">
					<div class="slider_img-banner">
						<img :src="item.imgTit" alt="" />
						<div class="left-img-btns">
							<span @click.stop="openCode()" class="btn">我要寄存</span>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
		<div style="background-color: #fff;">
			<div class="member">
				<h2 class="member-t">流转时光寄存</h2>
				<p class="member-p">寄存期内，支持随时取回</p>
				<div class="member-img">
					<img src="../../static/deposit/fwlc.png" alt="" />
				</div>
			</div>
		</div>
		<div class="cate1">
			<h2 class="cate1-t">多种交易方式</h2>
			<p class="cate1-p">系统化管理，流程看得见，安心寄存每一单！</p>
			<div class="cate-flex">
				<div class="member-img-item">
					<img src="../../static/deposit/icon1.png" alt="" />
					<div class="menber-btn">
						<div class="menber-btn-t">同城免费上门</div>
						<p class="menber-btn-desc">最快30分钟内</p>
					</div>
				</div>
				<div class="member-img-item">
					<img src="../../static/deposit/icon2.png" alt="" />
					<div class="menber-btn">
						<div class="menber-btn-t">快递邮寄</div>
						<p class="menber-btn-desc">全国可寄</p>
					</div>
				</div>
				<div class="member-img-item">
					<img src="../../static/deposit/icon3.png" alt="" />
					<div class="menber-btn">
						<div class="menber-btn-t">前往门店</div>
						<p class="menber-btn-desc">实体门店，到店服务</p>
					</div>
				</div>
			</div>
			<div class="transaction">
				<span class="transaction-btn"  @click.stop="openCode()">我要寄存</span>
			</div>
		</div>
		<ConsultDialog v-if="centerDialogVisible" @close="close"></ConsultDialog>
	</div>
</template>
<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	import ConsultDialog from '@/components/ConsultDialog.vue'
	export default {
		name: 'Index',
		components: {ConsultDialog},
		data() {
			return {
				centerDialogVisible: false,
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
			}
		},
		methods: {},
		mounted() {
			this.sliders = [{
						img: require('../../static/recycle/1banner.png'),
						imgTit: require('../../static/recycle/top-banner1-t.png')
					},
				],
				// 首次加載時，初始化高度
				this.screeWith = window.innerWidth
			this.bannerHeight = 560 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 560 / 1920 * this.screeWith
			}
		},
		computed: {
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
		methods: {
			close(flag) {
				this.centerDialogVisible = false
			},
			openCode() {
				this.centerDialogVisible = true
			},
		}
	}
</script>

<style scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #ff717b !important;
	}

	.border_parent {
		width: 90%;
		margin: auto;
	}

	.banner-item {
		position: relative;
	}

	.left-img-btns {
		margin-top: 40px;
	}

	.btn {
		display: inline-block;
		width: 200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
		cursor: pointer;
		background: #1684FC;
		border-radius: 30px;
	}
	.slider_img {
		height: 460px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
	}

	.slider_img-banner {
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}

	.slider_img .slider_img-banner img {
		width: 454px;
		height: 124px;
		margin-top: 100px;
	}

	.member {
		width: 1520px;
		margin: 0 auto;
		padding-top: 70px;
		margin-bottom: 15px;
		padding-bottom: 70px;
	}

	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}

	.member-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.member-img {
		width: 1520px;
		margin: 0 auto;
	}
	.member-img img {
		width: 100%;
		height: auto;
	}
	
	.cate1 {
		padding-top: 70px;
		padding-bottom: 70px;
		width: 1200px;
		margin: 0 auto;
	}
	
	.cate1-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.cate1-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.cate-flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.member-img-item {
		position: relative;
		cursor: pointer;
	}
	
	.member-img-item img {
		width: 360px;;
		height: 172px;
	}
	
	.menber-btn {
		position: absolute;
		left: 40px;
		top: 50%;
		transform: translateY(-50%);
		z-index: 10;
	}
	
	.menber-btn .menber-btn-t {
		font-weight: 600;
		font-size: 26px;
		color: #333333;
	}
	
	.menber-btn .menber-btn-desc {
		font-size: 13px;
		color: #FE3D3A;
	}
	
	.member-img-item:hover .menber-btn-t {
		color: #FE3D3A;
	}
	
	.transaction {
		text-align: center;
		margin-top: 60px;
	}
	
	.transaction-btn {
		display: inline-block;
		width: 200px;
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		border: 1px solid #FE3D3A;
		text-align: center;
		font-weight: 500;
		font-size: 20px;
		color: #FE3D3A;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/view/recycle.vue